export const darkPurple = '#331D4E';
export const pink = '#F2385A';
export const lightPurple = '#7C2E94';
export const bright = '#F2EFEF';
export const darkBlue = '#243B76';
export const darkGrey = '#858585';
export const brightGrey = '#D3D3D3';
export const almostBlack = '#515151';
export const logoPurple = '#451C31';
